import * as React from 'react';
import { observer } from 'mobx-react';
import Files from '../Files';
import SectionEnum from '../SectionEnum';
import { currentPurchaseContractStore as store, ContractDocumentInterface, languageStore } from 'stores';
import EmailCorrespondence from 'components/EmailCorrespondence';

@observer class Correspondence extends React.Component {

    render() {

        return (
            <Files
                title={languageStore.get('correspondence')}
                hash={SectionEnum.FILES_CORRESPONDENCE}
                store={store}
                files={store.contract!.contractCorrespondances}
                editDescription={<EmailCorrespondence contractId={store.contract!.id} />}
                onAddFileToContract={(document: ContractDocumentInterface) => store.addDocumentToContract(document, 'correspondance', store.contract!.contractCorrespondances)}
                onUpdateFile={(document: ContractDocumentInterface) => store.updateDocument(document, store.contract!.contractCorrespondances)}
                onDeleteFileFromContract={(document: ContractDocumentInterface) => store.deleteDocument(document, 'correspondance', store.contract!.contractCorrespondances)} />
        )
    }

}

export default Correspondence;